module.exports = __webpack_public_path__ + "img/background.f5ba7931.jpg";